module.exports = __webpack_public_path__ + "static/media/neutral_slightly-happy.d6e66069.svg";